var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"footer",attrs:{"fluid":"","d-flex":"","justify-center":""}},[_c('span',[_vm._v("© 2018 Mastodon Meetup at Tokyo")])])}
var staticRenderFns = []

export { render, staticRenderFns }